module.exports = __webpack_public_path__ + "img/Offre_Speciale2.a016c51a.png";